export function meshes(state) {
  return state.meshes;
}
export function meshesMeta(state) {
  return state.meshesMeta;
}
export function selectedMesh(state) {
  return state.selectedMesh;
}
export function expandedMeshes(state) {
  return state.expandedMeshes;
}
export function expandedCuis(state) {
  return state.expandedCuis;
}